import { Directive, OnDestroy, Input, Renderer, Host, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { UISrefStatus, SrefStatus } from '@uirouter/angular';

@Directive({
  selector: '[appUiSrefNotActive]'
})
export class UiSrefNotActiveDirective implements OnDestroy {

  constructor(
    uiSrefStatus: UISrefStatus,
    renderer: Renderer,
    @Host() el: ElementRef
  ) {
    this._subscription = uiSrefStatus.uiSrefStatus.subscribe((next: SrefStatus) => {
      this._classes.forEach(cls => renderer.setElementClass(el.nativeElement, cls, !next.active));
    });
  }

  @Input('appUiSrefNotActive') set active(val: string) { this._classes = val.split("\s+") };

  private _classes: string[] = [];
  private _subscription: Subscription;

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/directives/ui-sref-not-active.directive.ts